import {
  Button,
  Col,
  Input,
  // Pagination,
  Popover,
  Row,
  // Skeleton,
  Table,
} from "antd";
// import { useState } from "react";
import { FaEye, FaSearch } from "react-icons/fa";
import { MdTune } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";

const NewCarRequest = () => {
  // const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // const [paginationConfig, setPaginationConfig] = useState({
  //   pageNumber: 1,
  //   limit: 10,
  //   totalDocs: 0,
  //   totalPages: 0,
  // });
  // const startIndex =
  //   (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  // const endIndex = Math.min(
  //   startIndex + paginationConfig.limit - 1,
  //   paginationConfig.totalDocs
  // );
  // const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  const cars = [
    {
      key: "1",
      carName: "Tesla Model S",
      driverName: "John Doe",
      carModel: "2023",
      carNumber: "ABC-1234",
      registrationDate: "2023-01-15",
      status: "Pending",
      _id: "id1",
    },
    {
      key: "2",
      carName: "BMW X5",
      driverName: "Jane Smith",
      carModel: "2022",
      carNumber: "XYZ-5678",
      registrationDate: "2023-02-20",
      status: "Pending",
      _id: "id2",
    },
    {
      key: "3",
      carName: "Mercedes-Benz C-Class",
      driverName: "Alice Johnson",
      carModel: "2021",
      carNumber: "LMN-9101",
      registrationDate: "2023-03-05",
      status: "Rejected",
      _id: "id3",
    },
    {
      key: "4",
      carName: "Audi Q7",
      driverName: "Bob Brown",
      carModel: "2023",
      carNumber: "QRS-2345",
      registrationDate: "2023-04-10",
      status: "Rejected",
      _id: "id4",
    },
    {
      key: "5",
      carName: "Toyota Camry",
      driverName: "Eve White",
      carModel: "2020",
      carNumber: "TUV-6789",
      registrationDate: "2023-05-25",
      status: "Pending",
      _id: "id5",
    },
  ];

  // const itemRender = (_, type, originalElement) => {
  //   if (type === "prev") {
  //     return (
  //       <button type="button" className="pagination-link">
  //         Previous
  //       </button>
  //     );
  //   }
  //   if (type === "next") {
  //     return (
  //       <button type="button" className="pagination-link">
  //         Next
  //       </button>
  //     );
  //   }

  //   return originalElement;
  // };
  //   const filterContent = (
  //     <div className="filterDropdown">
  //       <div>
  //         <p className="mainLabel" style={{ padding: "10px" }}>
  //           Filter
  //         </p>
  //       </div>
  //       <hr style={{ margin: 0 }} />

  //       <div className="filterDropdownBody">
  //         <p className="mainLabel">Sort By:</p>
  //         <DatePicker
  //           className="mainInput filterInput"
  //           value={filter.from}
  //           onChange={(e) => handleFrom(e)}
  //         />
  //         <DatePicker
  //           className="mainInput filterInput"
  //           value={filter.to}
  //           onChange={(e) => handleTo(e)}
  //         />

  //         <p className="mainLabel">Filter by Status:</p>

  //         <Select
  //           size={"large"}
  //           className="filterSelectBox"
  //           placeholder="Select Status"
  //           value={filter.status}
  //           onChange={(e) => handleStatusChange(e)}
  //           style={{
  //             width: "100%",
  //             marginBottom: "10px",
  //             textAlign: "left",
  //           }}
  //           options={[
  //             { value: "ACTIVE", label: "Active" },
  //             { value: "INACTIVE", label: "Inactive" },
  //           ]}
  //         />

  //         <Button
  //           type="primary"
  //           shape="round"
  //           block
  //           size={"large"}
  //           style={{ marginBottom: "10px" }}
  //           className="mainButton primaryButton"
  //           onClick={() => getUsers()}
  //         >
  //           Apply
  //         </Button>
  //         <Button
  //           type="primary"
  //           shape="round"
  //           block
  //           size={"large"}
  //           className="mainButton primaryButton2"
  //           onClick={() => resetFilter()}
  //         >
  //           Clear All
  //         </Button>
  //       </div>
  //     </div>
  //   );

  const columns = [
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          S.NO
        </p>
      ),
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {(index < 10 && "0") + (index + 1)}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car Name
        </p>
      ),
      dataIndex: "carName",
      key: "carName",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.carName}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          driverName
        </p>
      ),
      dataIndex: "driverName",
      key: "driverName",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.driverName}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car Model
        </p>
      ),
      dataIndex: "carModel",
      key: "carModel",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.carModel}
        </p>
      ),
    },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car number
        </p>
      ),
      dataIndex: "carNumber",
      key: "carNumber",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.carNumber}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          registeration date
        </p>
      ),
      dataIndex: "registrationDate",
      key: "registrationDate",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.registrationDate}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Status
        </p>
      ),
      dataIndex: "status",
      key: "status",
      render: (value, item, index) => (
        <p
          className={`text-xs text-center font-euclid text-[#575757] ${
            item.status.toLowerCase() === "pending"
              ? "text-[#F26B1F]"
              : "text-[#E0010A]"
          }`}
        >
          {item.status}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          action
        </p>
      ),
      dataIndex: "_id",
      key: "_id",
      render: (item) => (
        <div className="flex justify-center">
          <div className="flex justify-center bg-[#FDE6C3] rounded-[100%] w-fit p-2 mr-1">
            <FaEye
              className="text-[#CD810D] cursor-pointer h-[16px] w-[16px]"
              //   onClick={() => navigate("/learner-management/" + item)}
            />
          </div>
        </div>
      ),
    },
  ];
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div className="flex justify-between items-center my-8">
          <div className="flex justify-center items-center">
            <IoIosArrowRoundBack
              onClick={() => navigate(-1)}
              className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
            />
            <h3 className="font-tavi laptop:text-3xl text-lg font-normal text-black">
              Car Request
            </h3>
          </div>

          <div className="flex justify-center items-center">
            <div className=" w-[250px] max-md:w-[120px]">
              <Input
                className="mainInput dashInput h-full"
                placeholder="Search"
                //   onChange={(e) => handleSearch(e.target.value)}
                suffix={
                  <FaSearch
                    style={{
                      color: "#818181",
                      fontSize: 16,
                      cursor: "pointer",
                    }}
                    //   onClick={() =>
                    //     getUsers(1, paginationConfig.limit, filter.keyword)
                    //   }
                  />
                }
                //   onPressEnter={(e) =>
                //     getUsers(1, paginationConfig.limit, filter.keyword)
                //   }
              />
            </div>
            &emsp;
            <div className="flex justify-center">
              <Popover
                //   content={filterContent}
                trigger="click"
                //   open={open}
                //   onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button
                  style={{
                    padding: "4px 11px",
                    height: "auto",
                    borderRadius: "6px",
                    backgroundColor: "white",
                  }}
                >
                  <MdTune className="max-xl:text-[24px] text-[32px] text-[#767676]" />
                </Button>
              </Popover>
            </div>
          </div>
        </div>
        <div
          className="bg-white rounded-lg  py-8 my-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <Row style={{ overflow: "auto" }} className="px-6">
            <Table
              className="styledTable"
              dataSource={cars}
              columns={columns}
              pagination={false}
            />
          </Row>
          {/* <Row style={{ padding: "10px 20px" }}>
            <Col xs={24} md={12}>
              <p className="font-euclid text-sm text-black">{message}</p>
            </Col>
            <Col
              xs={24}
              md={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Pagination
                className="styledPagination"
                // onChange={(e) => handlePageChange(e)}
                current={parseInt(paginationConfig.pageNumber)}
                pageSize={paginationConfig.limit}
                total={paginationConfig.totalDocs}
                itemRender={itemRender}
              />
            </Col>
          </Row> */}
        </div>
      </Col>
    </Row>
  );
};

export default NewCarRequest;
